import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Icon from 'flow/components/ui-components/Icon';
import Popover from 'flow/components/ui-components/Popover';
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { usePopper } from 'react-popper';
import { jsx as _jsx } from "react/jsx-runtime";
var PopoverMenu = function PopoverMenu(_ref) {
  var closeOnMouseLeave = _ref.closeOnMouseLeave,
    children = _ref.children,
    _ref$popoverClassName = _ref.popoverClassName,
    popoverClassName = _ref$popoverClassName === void 0 ? '' : _ref$popoverClassName,
    icon = _ref.icon,
    placement = _ref.placement,
    _ref$preventOverflow = _ref.preventOverflow,
    preventOverflow = _ref$preventOverflow === void 0 ? false : _ref$preventOverflow,
    backgroundColor = _ref.backgroundColor,
    onClickOpen = _ref.onClickOpen,
    triggerLabel = _ref.triggerLabel;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    referenceElement = _useState2[0],
    setReferenceElement = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    popperElement = _useState4[0],
    setPopperElement = _useState4[1];
  var _usePopper = usePopper(referenceElement, popperElement, {
      placement: placement,
      modifiers: [{
        name: 'flip',
        enabled: true,
        options: {
          flipVariations: true,
          allowedAutoPlacements: ['bottom-start', 'top-start', 'bottom-end']
        }
      }, {
        name: 'preventOverflow',
        enabled: preventOverflow
      }]
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  return /*#__PURE__*/_jsx(Popover, {
    icon: /*#__PURE__*/_jsx("div", {
      ref: setReferenceElement,
      className: "flex",
      children: icon || /*#__PURE__*/_jsx(Icon, {
        className: "cursor-pointer",
        iconKey: "more_vert"
      })
    }),
    onClickOpen: onClickOpen,
    className: popoverClassName,
    closeOnMouseLeave: closeOnMouseLeave,
    backgroundColor: backgroundColor,
    placement: placement,
    triggerLabel: triggerLabel,
    children: /*#__PURE__*/createPortal(/*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
      ref: setPopperElement,
      style: styles.popper
    }, attributes.popper), {}, {
      className: "z-50 -me-2 mt-2",
      children: children
    })), document.getElementById('contextMenuPortal'))
  });
};
export default PopoverMenu;